module.exports = __webpack_public_path__ + "static/media/corporate-services-img9.07055d4a.jpg";